Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTheme = exports.Provider = void 0;
var Provider_1 = require("./Provider");
Object.defineProperty(exports, "Provider", { enumerable: true, get: function () { return Provider_1.Provider; } });
var buildTheme_1 = require("./buildTheme");
Object.defineProperty(exports, "buildTheme", { enumerable: true, get: function () { return buildTheme_1.buildTheme; } });
exports.default = Provider_1.Provider;
//# sourceMappingURL=index.js.map